export const openMarketplaceCheckoutPopup = () => {
  const popUpWidth = 1080;
  const popUpHeight = 830;
  const { availHeight, availWidth } = window.screen;
  const left = availWidth / 2 - popUpWidth / 2;
  const top = availHeight / 2 - popUpHeight / 2;

  // We define the size and position of the popup so it displays in the center of the screen
  let popupSizeString: string | undefined =
    `width=${popUpWidth},height=${popUpHeight},left=${left},top=${top}`;

  // If screen too narrow for the popup we set the string to undefined
  // This makes it so the browser opens the content in a new tab (depends on browser)
  if (availWidth < popUpWidth) {
    popupSizeString = undefined;
  }

  const url =
    'https://marketplace.rio.cloud/checkout/1?productId=MAN-SKU00000066&popup=true&level=14';

  window.open(url, 'marketplaceCheckoutPopup', popupSizeString);
};
